var m = require('mithril');
var prop = require('mithril/stream');
var key = require('../../libs/keybindings');
var Model = require('../../libs/Model');
var modal = require('../../layout/components/modal');
var loaders = require('../../layout/components/loaders');
var treeDashboard = require ('../../components/treeDashboard');
var treeLocation = require ('../../locations/treeLocation');
var Dashboard = Object.assign(require('../../../../../models/dashboards/dashboard'), Model);
var DashboardTree = {root: Dashboard, name: 'Home', leafClass: 'Dashboard', edgeClass: 'Contains', ancestorClass: 'ancestors', '@id': '/api/v1/dashboardonly/'};

var moveElementModal = Object.create(Model);

modal.once('closed', function () {
  key.deleteScope('modal');
  key.setScope('home');
});

function getRequestErrorMessage(error) {
  if (!error) return '';
  if (typeof error === 'string') return error;
  if (error.error) return error.error;
  if (error.message) return error.message;
  if (error.body && error.body.error) return error.body.error;
  return '';
}

moveElementModal.editDialogue = function (record, options) {
  moveElementModal.newParentId = prop('')
  moveElementModal.record = record
  moveElementModal.errors = [];
  key.setScope('modal');
  var submit = () => {
    moveElementModal.errors = [];
    var newParent = moveElementModal.newParentId();
    var newParentRid = newParent && newParent['@rid'];
    if (!newParentRid) {
      moveElementModal.errors = [
        moveElementModal.record['@class'] == 'Contains'
          ? 'Select a parent dashboard before saving.'
          : 'Select a parent location before saving.'
      ];
      m.redraw();
      return false;
    }

    var body = {
      out: newParentRid.slice(1),
      in: moveElementModal.record.in
    };

    return loaders.requestWithLoader({
      loader: 'submit',
      url: `/api/v1/${record['@class']}/${moveElementModal.record['@rid'].slice(1)}`,
      method: 'PUT',
      body: body
    })
    .then(function (result) {
      key.unbind('enter');
      options && options.submitCallback ? options.submitCallback() : '';
      modal.vm.close();
      m.redraw();
    })
    .catch(function (error) {
      moveElementModal.errors = [getRequestErrorMessage(error) || 'Unable to move this element.'];
      m.redraw();
      return Promise.reject(error);
    });
  };
  key('enter', 'modal', submit);

  modal.vm.title('Move Element: ')
  modal.vm.body = moveElementModal.view,
  modal.vm.buttons([
    {
      label: "Save",
      class: "btn-good",
      func: submit
    }
  ]);
  modal.vm.open();
}


moveElementModal.view = function () {
  return m('form', {role:'form'}, [
    moveElementModal.errorView(),
    moveElementModal.record['@class'] == 'Contains' ?
      m(treeDashboard, {trees: [DashboardTree], selector: moveElementModal.newParentId, label:'parent dashboard'})
    :
      m(treeLocation, {selectedNode: moveElementModal.newParentId, label:'parent location'})
  ])  
}

module.exports = moveElementModal;
